import { http } from "./api";

const b64 = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const r = atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...r].map((c) => c.charCodeAt(0))); };
const enc = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
const same = (a, b) => a && b && a.byteLength === b.byteLength && new Uint8Array(a).every((v, i) => v === b[i]);

export const subscribePush = async (keyPath, subPath) => {
  const reg = await navigator.serviceWorker.ready;
  const key = b64((await http.get(keyPath)).data.public_key);
  let sub = await reg.pushManager.getSubscription();
  if (sub && !same(sub.options?.applicationServerKey, key)) { await sub.unsubscribe(); sub = null; }
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  await http.post(subPath, { endpoint: sub.endpoint, keys: { p256dh: enc(sub.getKey("p256dh")), auth: enc(sub.getKey("auth")) } });
  return sub;
};

// Re-registers silently when the server key changed, so alerts keep arriving.
export const syncPush = async (keyPath, subPath) => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || Notification.permission !== "granted") return false;
  const sub = await (await navigator.serviceWorker.ready).pushManager.getSubscription();
  if (!sub) return false;
  await subscribePush(keyPath, subPath);
  return true;
};
